import { render, staticRenderFns } from "./OccupyOrder.vue?vue&type=template&id=9d870ec6&"
import script from "./OccupyOrder.vue?vue&type=script&lang=js&"
export * from "./OccupyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports